import MenuItem from "./MenuItem";

/** Parse Strapi multi-value fields that may be arrays or JSON-encoded strings. */
export const parseJsonArray = (raw) => {
  if (Array.isArray(raw)) return raw;
  if (typeof raw === "string") {
    const trimmed = raw.trim();
    if (!trimmed) return [];
    try {
      const parsed = JSON.parse(trimmed);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [trimmed];
    }
  }
  return [];
};

export const getMenuCategories = (item) => {
  const fromJson = parseJsonArray(item?.category_json);
  if (fromJson.length) return fromJson;
  return parseJsonArray(item?.category);
};

export const getWhichMenus = (item) => parseJsonArray(item?.which_menu);

const Section = ({ items, category, lastItem, children, compact }) => {
  if (!items) {
    return <section>{children}</section>;
  }

  const itemList = items.filter((x) => getMenuCategories(x).includes(category));

  return (
    <div
      className={`menu-item-list${compact ? " menu-item-list--compact" : ""}`}
    >
      {itemList.map(
        (x) =>
          x && (
            <MenuItem
              key={x.id}
              menuItem={x}
              category={category}
              compact={compact}
            />
          )
      )}
      {lastItem && lastItem()}
    </div>
  );
};

export default Section;
